import React from 'react'
import ReactDOM from 'react-dom';
import 'semantic-ui-css/semantic.min.css'
import StickyLayout from './layout.jsx'
import ErrorLayout from './error_layout.jsx'

class App extends React.Component {

    constructor(props) {
        super(props);
        this.state = {errorOccurred: false, errorInfo: ""};
    }

    static getDerivedStateFromError(error) {
        return {errorOccurred: true, errorInfo: error.message + "\n" + error.stack};
    }

    render() {
        const {errorOccurred, errorInfo} = this.state;
        if (errorOccurred) {
            return (
                <ErrorLayout errorInfo={errorInfo}/>
            )
        } else {
            return (
                <StickyLayout/>
            );
        }

    }
}

ReactDOM.render(<App/>, document.getElementById('app'));
